const messages = {
  name: 'Precios Por Defecto',
  dialog: {
    title: 'Detalles de Precios Por Defecto',
  },
  actions: {
    addDefaultPricing: 'Anadir Precio Por Defecto',
  },
  fields: {
    communicationChannel: 'Canal de Comunicacion',
    amount: 'Precio Por Unidad',
  },
  filters: {
    communicationChannel: 'Canal de Comunicacion',
    amount: 'Precio Por Unidad',
  },
  validation: {
    selectChannel: 'Selecciona Canal',
    enterValidPrice: 'Introduce un precio valido',
  },
  sections: {
    pricing: 'Detalles de Precio',
  },
  help: {
    pricing: 'Establece el precio por defecto cobrado por mensaje para cada canal de comunicacion.',
    createBanner: 'Anade un nuevo precio por defecto para un canal de comunicacion.',
    editBanner: 'Actualiza el precio por defecto para este canal de comunicacion.',
  },
  create: {
    title: 'Crear Precio',
  },
  edit: {
    title: 'Editar Precio',
  },
  delete: {
    title: 'Eliminar precio para "%{recordName}"',
    content: 'Seguro que quieres eliminar esta entrada de precio? Esta accion no se puede deshacer.',
  },
  notifications: {
    created: 'Precio guardado correctamente',
    updated: 'Precio guardado correctamente',
    deleted: 'Precio eliminado correctamente',
  },
};

export default messages;
